import Auth from '../auth'
import Axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL_API = process.env.REACT_APP_BASE_URL_API;

const getHeaderConfig = () =>
    ({
        headers: {
            Accept: 'application/json',
            Authorization: Auth.getAccessToken()
        }
    })

const makeRequest = {
    get: async (resource, api_laravel = false) => {
        var url = api_laravel ? BASE_URL_API : BASE_URL+'/edu';
        var rawResponse = await Axios.get(`${url}/${resource}`, getHeaderConfig());
        var responseBody = parseResponse(rawResponse, resource);
        return responseBody;
    },

    "delete": async (resource, api_laravel = false) => {
        var url = api_laravel ? BASE_URL_API : BASE_URL+'/edu';
        var rawResponse = await Axios.delete(`${url}/${resource}`, getHeaderConfig());
        var responseBody = parseResponseWithError(rawResponse, resource);

        return responseBody;
    },

    post: async (resource, data, api_laravel = false) => {
        var url = api_laravel ? BASE_URL_API : BASE_URL+'/edu';
        var rawResponse = await Axios.post(`${url}/${resource}`, data, getHeaderConfig());
        var responseBody = parseResponse(rawResponse, resource);

        return responseBody;
    },

    put: async (resource, data, api_laravel = false) => {
        var url = api_laravel ? BASE_URL_API : BASE_URL+'/edu';
        console.log('put resource ',resource)
        console.log('put data ',data)
        var rawResponse = await Axios.put(`${url}/${resource}`, data, getHeaderConfig());
        var responseBody = parseResponse(rawResponse, resource);

        return responseBody;
    }
}

function parseResponse(response, resource, isSafari) {

    if (!response.data) {
        throw new Error("Invalid response.");
    }

    if (response.data.errorMessage) {
        throw new Error(`Response error ${resource}: ${response.data.errorMessage}`);
    }

    var responseBody = undefined
    try {
        if(response.data.data) {
            responseBody = response.data.data;
        }else if(response.data.body) {
            responseBody = JSON.parse(response.data.body);
        }else{
            responseBody = response.data;
        }
    } catch (error) {
        responseBody = response.data.body
    }

    return responseBody;
}

function parseResponseWithError(response, resource, isSafari) {

    if (!response.data) {
        throw new Error("Invalid response.");
    }

    if (response.data.errorMessage) {
        throw new Error(`Response error ${resource}: ${response.data.errorMessage}`);
    }

    var responseBody = undefined
    try {
        responseBody = JSON.parse(response.data.body);
    } catch (error) {
        if(response.data.body) {
            responseBody = response.data.body
        }
        else {
            responseBody = response.data
        }
    }

    return responseBody;
}

export default makeRequest;
